<template>
    <div class="reader min-h-screen bg-reader-bg text-reader-text transition-colors duration-300"
         :class="[themeClasses, { hidePage: isPendingRestore }]"
         @contextmenu.prevent>
        <!-- 顶部导航 -->
        <header class="fixed top-0 left-0 right-0 bg-reader-bg/80 backdrop-blur-sm z-10 border-b border-gray-200/30">
            <div class="container mx-auto px-4 py-3 flex items-center justify-between">
                <button @click="goBack" class="flex items-center text-reader-text hover:text-primary">
                    <i class="fa fa-arrow-left mr-2"></i>
                    <span class="text-sm">返回</span>
                </button>

                <div class="flex items-center space-x-6">
                    <!-- 字体大小调整 -->
                    <div class="flex items-center space-x-2">
                        <button @click="decreaseFontSize" class="text-reader-text hover:text-primary">
                            <i class="fa fa-font text-sm"></i>
                        </button>
                        <span class="text-xs">{{ fontSize }}px</span>
                        <button @click="increaseFontSize" class="text-reader-text hover:text-primary">
                            <i class="fa fa-font text-lg"></i>
                        </button>
                    </div>

                    <!-- 主题切换 -->
                    <button @click="toggleTheme"
                            class="text-reader-text hover:text-primary p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors">
                        <i :class="themeIcon"></i>
                    </button>

                    <!-- 目录 -->
                    <button @click="toggleToc" class="text-reader-text hover:text-primary">
                        <i class="fa fa-list-ul"></i>
                    </button>
                </div>
            </div>
        </header>
        <!-- 阅读区域 -->
        <main v-if="safeChapterData" class="container mx-auto px-4 py-24 md:py-32 max-w-3xl">
            <!-- 章节标题 -->
            <h1 class="text-[clamp(1.5rem,3vw,2.5rem)] font-bold text-center mb-8 text-reader-title">
                {{ safeChapterData.title }}
            </h1>

            <!-- 发布日期 -->
            <div class="text-center text-sm text-reader-secondary mb-12">
                发布于 {{ safeChapterData.createdAt.substring(0, 10) }} | 字数：{{ safeChapterData.wordCount }}
            </div>
            <!-- 正文内容 -->

            <!--            &lt;!&ndash; 正文内容 &ndash;&gt;-->
                        <div v-if="htmlContent"
                            class="prose prose-lg prose-slate max-w-none text-reader-text"
                            :style="{ 'font-size': `${fontSize}px`, 'line-height': lineHeight }"
                        >
            <!--                HTML会自动忽略换行符和连续空格-->
                            <div v-html="htmlContent" class="prose max-w-none dark:prose-invert"></div>
                        </div>
            
            <!-- 分页导航 -->
            <div class="flex justify-between mt-16">
                <button
                    class="px-6 py-3 rounded-full bg-primary/10 hover:bg-primary/20 text-primary transition-colors"
                    @click="prevChapter(safeChapterData.id)"
                    :disabled="isFirstChapter"
                >
                    上一章
                </button>
                <!-- 打赏按钮 -->
                <!-- <button
                    class="px-6 py-3 rounded-full bg-primary/20 hover:bg-primary/30 text-primary font-semibold ring-1 ring-primary/40 shadow-sm hover:shadow-md transition-all duration-200"
                    @click="goToEncourage"
                >
                    打赏
                </button> -->

                <button
                    class="px-6 py-3 rounded-full bg-primary/10 hover:bg-primary/20 text-primary transition-colors"
                    @click="nextChapter(safeChapterData.id)"
                    :disabled="isLastChapter"
                >
                    下一章
                </button>


            </div>
        </main>

        <!-- 底部导航 -->
        <!--        <footer class="fixed bottom-0 left-0 right-0 bg-reader-bg/80 backdrop-blur-sm z-10 border-t border-gray-200/30">-->
        <!--            <div class="container mx-auto px-4 py-3 flex items-center justify-center">-->
        <!--                <button @click="goToToc" class="px-4 py-2 rounded-full bg-primary text-white text-sm">-->
        <!--                    目录-->
        <!--                </button>-->
        <!--            </div>-->
        <!--        </footer>-->

        <!-- 章节列表侧边栏 -->
        <div
            class="fixed top-0 right-0 bottom-0 w-72 bg-white shadow-xl transform translate-x-full transition-transform duration-300 z-20"
            :class="{ '-translate-x-0': tocVisible }"
        >
            <div class="p-4 border-b">
                <h3 class="font-medium">章节列表</h3>
                <button @click="toggleToc" class="absolute top-4 right-4">
                    <i class="fa fa-times"></i>
                </button>
            </div>

            <div class="p-2 overflow-y-auto h-full">
                <div v-if="ChapterIntroduceData">
                    <div
                        v-for="chapter in ChapterIntroduceData"
                        :key="chapter.id"
                        class="px-3 py-2 rounded hover:bg-gray-100 cursor-pointer text-sm"
                        :class=" 'bg-primary/10 font-medium' "
                        @click="selectChapter(chapter.id)"
                    >
                        {{ chapter.title }}
                    </div>
                </div>

            </div>
        </div>

        <!-- 遮罩层 -->
        <div
            class="fixed inset-0 bg-black/30 z-10 opacity-0 pointer-events-none transition-opacity duration-300"
            :class="{ 'opacity-100 pointer-events-auto': tocVisible }"
            @click="toggleToc"
        ></div>
        <!-- 提示框组件（可自定义样式） -->
        <!--        <div v-if="showToast" class="fixed bottom-4 left-1/2 transform -translate-x-1/2 bg-gray-800 text-white px-4 py-2 rounded shadow-lg z-50">-->
        <!--            {{ toastMessage }}-->
        <!--        </div>-->
    </div>
</template>

<script setup>
import {ref, computed, onMounted, onBeforeUnmount, watch, onUnmounted} from 'vue'
import {useRouter} from 'vue-router'
import {useChapterStore} from "@/store/chapter";
import {readerChapterWebSocket} from "@/services/ReaderChapterWebSocketService";
import {storeToRefs} from "pinia";
import {useDisableDevTools} from "@/composables/useDisableDevTools";

// 页面隐藏
const isPendingRestore = ref(true)

const chapterStore = useChapterStore();
// 将 currentChapter 转换为 ref
let {currentChapter} = storeToRefs(chapterStore);
// 使用计算属性安全获取嵌套值
const currentId = computed(() => currentChapter.value.id);
const currentNovelId = computed(() => currentChapter.value.novel_id);
// 通过WebSocket获取后端数据
const {
    connected, chapter_introduce, chapter_content, loading, error,
    fetchNovelsChapter, updateChapterParams
} = readerChapterWebSocket(currentId, currentNovelId);

const loadData = async () => {
    await fetchNovelsChapter();
};
const safeChapterData = computed(() => {
    const defaultValue = {
        id: '0',
        novelId: '0',
        title: '加载中...',
        wordCount: '0000',
        createdAt: '2005-01-25 00:00:00'
    };
    // 检查数据有效性
    if (!Array.isArray(chapter_introduce.value) || !currentId.value) {
        return defaultValue;
    }

    // 查找匹配章节
    const targetChapter = chapter_introduce.value.find(chapter =>
        String(chapter?.id) === String(currentId.value)
    );

    // 合并数据
    return {...defaultValue, ...(targetChapter || {})};
});

const ChapterIntroduceData = computed(() => {
    // 默认项结构（确保包含所有可能字段）
    const defaultItem = {
        id: '0',
        novel_id: '0',
        title: '加载中...',
        word_count: '0000',
        created_at: '2005-01-25 00:00:00'
    };

    // 1. 非数组直接返回默认数组
    if (!Array.isArray(chapter_introduce.value)) {
        return [defaultItem];
    }

    // 2. 空数组返回默认数组
    if (!chapter_introduce.value.length) {
        return [defaultItem];
    }

    // 3. 非空数组：用实际数据覆盖默认项的对应字段
    return chapter_introduce.value.map(item => ({
        ...defaultItem, // 默认值打底
        ...item         // 实际数据覆盖
    }));
});

// 阅读设置
const fontSize = ref(Number(localStorage.getItem('readerFontSize')) || 18)
const lineHeight = ref('1.8')
const tocVisible = ref(false)
// 目录切换
const toggleToc = () => {
    tocVisible.value = !tocVisible.value
}

// 插图数据（后续改为从后端获取）


// 状态锁：第一章与最后一章
const isLastChapter = ref(false);
const isFirstChapter = ref(false);

const processedContent = computed(() => {
    const defaultValue = {
        id: '0',
        novelId: '0',
        content: '加载中...',
    };

    // 合并数据
    return {...defaultValue, ...(chapter_content.value || {})};
});
const escapeHTML = (str) => {
    return str
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
};
let htmlContent = computed(() => {
    return processedContent.value.content
        .split('\n')
        .map(line => `<p class="text-left mb-5 " style="text-indent: 2em">${escapeHTML(line)}</p>`)
        .join('');
});
// 保存阅读进度到 localStorage
const saveReadingProgress = () => {
    if (!currentNovelId.value || !currentId.value) return
    const progress = {
        novelId: currentNovelId.value,
        chapterId: currentId.value,
        chapterTitle: safeChapterData.value?.title || '',
        scrollPosition: window.scrollY,
        updatedAt: new Date().toISOString()
    }
    console.log('保存阅读进度：', progress)
    localStorage.setItem(`read_progress_${currentNovelId.value}`, JSON.stringify(progress))
}

// 恢复阅读进度到上次滚动位置
const restoreReadingProgress = () => {
    if (!currentNovelId.value || !currentId.value) return
    const saved = localStorage.getItem(`read_progress_${currentNovelId.value}`)
    if (!saved) return
    try {
        const progress = JSON.parse(saved)
        if (progress.novelId == currentNovelId.value && progress.chapterId == currentId.value) {
            setTimeout(() => window.scrollTo(0, progress.scrollPosition), 200)
        }
    } catch (e) { /* ignore */ }
}

// 隐藏整个页面，等到渲染成功

//

// 生命周期钩子
onMounted(() => {
    // window.scrollTo(0, 0);
    loadData().catch(console.error);
    restoreReadingProgress()
    // 等待数据加载完成后恢复阅读位置
        setTimeout(() => {
        isPendingRestore.value = false
    }, 200)
    
    // setTimeout(restoreReadingProgress, 100)
    // 禁用开发者工具快捷键
    const cleanup = useDisableDevTools()
    onUnmounted(cleanup)
})
onBeforeUnmount(() => {
    // 关键：onBeforeUnmount 时阅读页 DOM 还在，window.scrollY 才是真实值；
    // 放到 onUnmounted 会晚于 DOM 移除，滚动位置已被浏览器归零 → 存进去永远是 0
    saveReadingProgress()
})
// 清理函数
onUnmounted(() => {
    // saveReadingProgress()
})

const router = useRouter()
// 导航函数
const goBack = () => {
    saveReadingProgress()
    if (window.history.length > 1) {
        router.back()
    } else {
        router.push({name: 'NovelChapterList', params: {id: currentNovelId.value}})
    }
}

// 打赏：跳转到打赏页面
// 用 push 而不是 replace —— 保留浏览器历史记录，浏览器自带的返回键才能回到当前阅读页
const goToEncourage = () => {
    // 跳转前先保存阅读进度（章节 + 滚动位置），返回阅读页时由 restoreReadingProgress 自动恢复
    saveReadingProgress()
    router.push({ name: 'Encourage' })
}

// 字体大小调整
const increaseFontSize = () => {
    if (fontSize.value < 28) {
        fontSize.value += 2
        localStorage.setItem('readerFontSize', fontSize.value.toString())
    }
}

const decreaseFontSize = () => {
    if (fontSize.value > 14) {
        fontSize.value -= 2
        localStorage.setItem('readerFontSize', fontSize.value.toString())
    }
}
// 定义支持的主题
const themes = {
    light: {
        bgColor: 'bg-white',
        textColor: 'text-gray-800',
        icon: 'fa-sun-o', // 太阳图标表示可切换到亮色模式
    },
    dark: {
        bgColor: 'bg-moon_bg',
        textColor: 'text-moon_font',
        icon: 'fa-moon-o', // 月亮图标表示可切换到暗色模式
    },
    sepia: {
        bgColor: 'bg-eye_bg',
        textColor: 'text-eye_font',
        icon: 'fa-eye', // 眼睛图标表示护眼模式
    },
    love: {
        bgColor: 'bg-love_bg',
        textColor: 'text-love_font',
        icon: 'fa-heart-o', // 眼睛图标表示护眼模式
    },
    child: {
        bgColor: 'bg-child_bg',
        textColor: 'text-child_font',
        icon: 'fa-heart', // 眼睛图标表示护眼模式
    }
};
// 当前主题状态（从 localStorage 读取，默认 light）
const currentTheme = ref(localStorage.getItem('readerTheme') || 'light');

// 计算属性：根据当前主题生成样式类
const themeClasses = computed(() => {
    const theme = themes[currentTheme.value];
    return `${theme.bgColor} ${theme.textColor} transition-colors duration-300`;
});

// 计算属性：根据当前主题显示图标
const themeIcon = computed(() => {
    return `fa ${themes[currentTheme.value].icon}`;
});
// 主题切换
const toggleTheme = () => {
    const themeOrder = ['light', 'dark', 'sepia', 'love', 'child'];
    const currentIndex = themeOrder.indexOf(currentTheme.value);
    const nextIndex = (currentIndex + 1) % themeOrder.length;
    currentTheme.value = themeOrder[nextIndex];
    localStorage.setItem('readerTheme', currentTheme.value);
}

// 更新章节状态（是否为第一章/最后一章）
const updateChapterStatus = (currentIndex) => {
    isFirstChapter.value = currentIndex === 0;
    isLastChapter.value = currentIndex === chapter_introduce.value.length - 1;
};
// 章节选择
const selectChapter = (id) => {
    // 切章前先保存当前进度
    saveReadingProgress()
    // 从全部章节数据中查找匹配ID的章节
    const numericId = Number(id);
    const currentIndex = chapter_introduce.value.findIndex(ch => ch.id === numericId);
    console.log(currentIndex)
    chapterStore.setCurrentChapter(id, currentNovelId.value);
    
    toggleToc()
    updateChapterStatus(currentIndex);
    updateChapterParams(id)
    window.scrollTo({
        top: 0,
    });
}
// 上下章导航
const prevChapter = (id) => {
    // 切章前先保存当前进度
    saveReadingProgress()
    const numericId = Number(id);
    const currentIndex = chapter_introduce.value.findIndex(ch => ch.id === numericId);
    if (currentIndex === -1) {
        console.error(`未找到 ID 为 ${id} 的章节`);
    }
    const nextIndex = currentIndex - 1;
    console.log("章节长度："+chapter_introduce.value.length)
    console.log("当前位置："+nextIndex)
    if (nextIndex >= 0) {
        const thisId = chapter_introduce.value[nextIndex].id;
        chapterStore.setCurrentChapter(thisId, currentNovelId.value);
        updateChapterParams(thisId)
        // 滚动到页面顶部
        updateChapterStatus(nextIndex);
        window.scrollTo({
            top: 0,
        });
    } else {
        // showToastMessage('已经是第一章');
        // 可以显示提示或禁用按钮
    }
    
}

const nextChapter = (id) => {
    // 切章前先保存当前进度
    saveReadingProgress()
    const numericId = Number(id);
    const currentIndex = chapter_introduce.value.findIndex(ch => ch.id === numericId);
    if (currentIndex === -1) {
        console.error(`未找到 ID 为 ${id} 的章节`);
    }
    const nextIndex = currentIndex + 1;
    if (nextIndex < chapter_introduce.value.length) {

        const thisId = chapter_introduce.value[nextIndex].id;
        console.log("当前id："+thisId)
        console.log("当前NovelId："+currentNovelId.value)
        // 更新处理后的内容
        chapterStore.setCurrentChapter(thisId, currentNovelId.value);
        updateChapterParams(thisId)
        updateChapterStatus(nextIndex);
        window.scrollTo({
            top: 0,
        });
    } else {

    }
    // 更新章节状态
    
}

</script>

<style scoped>
/* 阅读区域：禁止选中文本，使用默认光标 */
.reader {
    cursor: default;
    user-select: none;
}

/* 小说内容显示格式 */
.prose p {
    text-align: left !important; /* 设置文本左对齐 */
    text-indent: 2em; /* 保留首行缩进 */
    margin-bottom: 16px; /* 段落间距 */
}

/* 阅读模式基础样式 */
.prose {
    max-width: none;
}

.hidePage {
  visibility: hidden; /* 元素占位，不会导致布局抖动 */
  /* 不要用 display:none，会丢失页面高度，scrollTop 设置失效 */
}

/* 护眼配色方案 */
:root {
    --reader-bg: #f5f1e8;
    --reader-text: #333333;
    --reader-title: #222222;
    --reader-secondary: #666666;
}

/* 自定义滚动条 */
::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}

::-webkit-scrollbar-track {
    background: transparent;
}

::-webkit-scrollbar-thumb {
    background: rgba(156, 163, 175, 0.5);
    border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
    background: rgba(107, 114, 128, 0.5);
}
</style>